const { default: globalMU } = require("../../../globalMU");

window.PesquisaOrcamentoController = ControllerBase.extend({
    name: "PesquisaOrcamentoController",
    framework: "knockout",
    region: "#geral",

    newModel: function () {

        return {
            Orcamentos: [],
            Vendedores: [],
            NumeroPedido: null,
            NumeroPedidoCompra: null,
            CodigoVendedor: null,
            CodigoFilial: null,
            VendedorParaOrcamentoUnificado: null, // 427169
            CodigoCliente: null,
            NomeCliente: null,
            Situacao: null,
            DataInicial: new Date(),
            DataFinal: new Date(),
            OrcamentoSelecionado: null,
            PermitidoAlterar: false,
            PermitidoDuplicar: false,
            ValorTotalOrcamentos: null,
            JustificativaDuplicar: null,
            JustificativaAlterar: null,
            DesabilitarBotoes: false,
            NotaVenda: false,
            NotaDevolucao: false,
            NotasFiscais: false,
            NotaSelecionada: false,
            ItensNotaFiscal: false,
            ItemNotaFiscalSelecionado: false,
            TipoOrcamento: null,
            TipoOrcamentoNovo: null,
            PermiteTrocarFilial: null,
            ListaPedidosCompra: null
        };

    },

    initialize: function () {

        this.setModel(this.newModel());

        this.paramSolicitarSenhaTrocaFilialOrcamento = (parametroSistema.obter("SOLICITAR_SENHA_TROCA_FILIAL_ORCAMENTO").Valor === "S")
    },

    formConfig: {
        selector: "#form-pesquisar-pedido",
        submit: {
            callback: "pesquisar"
        },
        rules: {
            'Numero': {
                numberMaxValue: "int"
            },
            'DataInicial': {
                validateDate: true,
                dateGreaterThanOrEqual: "#form-pesquisar-pedido input[name=DataFinal]"
            },
            'DataFinal': {
                validateDate: true
            }
        },
        messages: {
            'Numero': {
                numberMaxValue: 'O campo "Número" é inválido'
            },
            'DataInicial': {
                required: 'O campo "Data Inicial" é obrigatório.',
                validateDate: 'O campo "Data Inicial" é inválido.',
                dateGreaterThanOrEqual: 'O campo "Data Inicial" não pode ser maior do que o campo "Data Final".'
            },
            'DataFinal': {
                required: 'O campo "Data Final" é obrigatório.',
                validateDate: 'O campo "Data Final" é inválido.'
            }
        },
        ignore: []

    },

    aposBinding: function () {

        this.model.NumeroPedido.subscribe($.proxy(function (newValue) {
            if (this.model.NumeroPedido()) {
                this.model.CodigoCliente(undefined);
                this.model.NomeCliente(undefined);
                this.model.NumeroPedidoCompra(undefined);
            }

        },
            this));

        this.model.CodigoCliente.subscribe($.proxy(function (newValue) {
            if (this.model.CodigoCliente()) {
                this.model.NumeroPedido(undefined);
                this.model.NumeroPedidoCompra(undefined);
            }
        },
            this));

        this.model.TipoOrcamento.subscribe($.proxy(function (newValue) {
            if (this.model.TipoOrcamento() && this.model.TipoOrcamento() === "TRA") {
                this.model.NumeroPedidoCompra(undefined);
            }
        },
            this));

        if (this.model.Vendedores && this.model.Vendedores().length == 1) {
            this.model.CodigoVendedor(this.model.Vendedores()[0].CodigoVendedor());
        }
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
        $('[data-toggle="popover"]').popover();

    },

    obterVendedores: function (e) {
        var self = this;
        if (self.model.CodigoFilial() != null) {
            global.ajax({
                url: "/Vendedor/ListarVendedoresPorFilial",
                type: "post",
                contentType: "application/json",
                data: global.toJSONString({
                    identificadorFilial: self.model.CodigoFilial()
                }),
                success: function (data) {
                    self.model.Vendedores(data);

                    if (self.vendedor) {
                        self.model.CodigoVendedor(self.vendedor);
                    }

                }
            });
        } else {
            self.model.Vendedores.removeAll();
        }
    },

    setFilial: function (codigoFilial, vendedorUnificacao) {
        this.model.CodigoFilial(codigoFilial);
        this.model.VendedorParaOrcamentoUnificado(vendedorUnificacao == "True");  // 427169
    },

    setVendedor: function (codigoVendedor) {
        this.vendedor = codigoVendedor;
    },

    setDataInicial: function (dataInicial) {
        this.model.DataInicial(global.toDate(dataInicial, "DD/MM/YYYY"));
    },

    setDataFinal: function (dataFinal) {
        this.model.DataFinal(global.toDate(dataFinal, "DD/MM/YYYY"));
    },

    setNumeroPedidoCompra: function (pedidoCompra) {
        this.model.NumeroPedidoCompra(pedidoCompra);
    },

    pesquisar: function (model, e, pagina) {

        if (!this.validateForm()) {
            return;
        }

        global.blockUI();
        this.model.OrcamentoSelecionado(null);
        var self = this;

        var filtros = this.toJS(this.model);
        filtros.TamanhoPagina = 20;
        filtros.NumeroPagina = pagina ? pagina : 1;

        global.ajax({
            url: "/Orcamento/PesquisarOrcamento",
            type: "post",
            contentType: "application/json",
            blockUI: true,
            data: global.toJSONString({
                filtros: filtros
            }),
            success: function (data) {
                if (data.PageMessage !== undefined && data.PageMessage !== null) {
                    self.model.Orcamentos(ko.mapping.fromJS(data.PageMessage.Entities)());
                    self.model.ValorTotalOrcamentos(data.ValorTotalOrcamentos);

                    GridController.start(self.region);

                    if (data.PageMessage.RowsCount > 0 || (data.PageMessage.Entities && data.PageMessage.Entities.length > 0)) {
                        $("html, body").animate({ scrollTop: $("#pesquisarOrcamento_FiltroTipoOrcamento").offset().top }, 500);

                    }
                } else {
                    self.model.Orcamentos.removeAll();
                    self.model.ValorTotalOrcamentos(undefined);
                }

                this.paginador = new Paginator({
                    container: "#page-pesquisar-orcamento",
                    data: data.PageMessage !== undefined && data.PageMessage !== null ? data.PageMessage : null,
                    pageClickCallback: $.proxy(self.paginar, self)
                });
                global.unblockUI();
            },
            error: function (error) {
                global.unblockUI();
            }
        });
    },

    paginar: function (e) {
        this.pesquisar(null, null, e.page);
    },

    podePesquisar: function (e) {
        var self = this;

        if ((self.model.DataInicial() != null && self.model.DataInicial() != "__/__/____") &&
            (self.model.DataFinal() != null && self.model.DataFinal() != "__/__/____") &&
            self.model.DataFinal() > self.model.DataInicial()) {
            self.model.habilitaPesquisa(true);
        } else {
            self.model.habilitaPesquisa(false);
        }
    },

    exibirHistorico: function () {

        if (!this.model.OrcamentoSelecionado || !this.model.OrcamentoSelecionado()) {
            return;
        }

        var orcamento = ko.mapping.toJS(this.model.OrcamentoSelecionado());

        this.pesquisaOrcamentoController = this.showView({
            region: {
                name: "historicoPedidosRegion",
                selector: "#historico-pedido-region"
            },
            controller: {
                type: HistoricoPedidoController,
                args: {
                    numeroPedido: this.model.OrcamentoSelecionado().NumeroPedido(),
                    orcamento: orcamento
                }
            }
        });
    },

    conhecimentoTransporte: function () {
        if (!this.model.OrcamentoSelecionado || !this.model.OrcamentoSelecionado()) {
            return;
        }

        this.pesquisaOrcamentoController = this.showView({
            region: {
                name: 'conhecimentoTransporteRegion',
                selector: '#conhecimento-Transporte-region'
            },
            controller: {
                type: ListarConhecimentoTransporteController,
                args: {
                    orcamento: this.model.OrcamentoSelecionado()
                }
            }
        })
    },

    pesquisarCliente: function () {

        this.pesquisarClientesController = this.showView({
            region: {
                name: "pesquisarClientesRegion",
                selector: "#pesquisar-clientes-pesquisa-orcamento-region"
            },
            controller: {
                type: PesquisarClientesController,
                args: {
                    clienteSelecionadoCallbackView: $.proxy(this.clienteSelecionado, this)
                }
            }
        });
    },

    removerCliente: function () {
        this.model.CodigoCliente(undefined);
        this.model.NomeCliente(undefined);
    },

    selecionar: function (model) {
        $.each(this.model.Orcamentos(),
            function () {
                this.selecionado(false);
            });

        model.selecionado(true);

        this.model.OrcamentoSelecionado(model);
        this.model.TipoOrcamentoNovo(model.TipoOrcamento()); // FNX-5036
        this.model.PermiteTrocarFilial(model.TipoOrcamento() == 'Venda' && ((this.paramSolicitarSenhaTrocaFilialOrcamento && model.CodigoSituacaoVenda() === 'A') ||
            (!this.paramSolicitarSenhaTrocaFilialOrcamento && (model.CodigoSituacaoVenda() === '0' || model.CodigoSituacaoVenda() === '1' || model.CodigoSituacaoVenda() === '5' || model.CodigoSituacaoVenda() === 'A')))
        );  // FNX-5036



        this.model.PermitidoDuplicar(model.PermiteDuplicar() );
        this.model.PermitidoAlterar(model.PermiteAlterar());
        this.model.JustificativaDuplicar(model.JustificativaDuplicar);
        this.model.JustificativaAlterar(model.JustificativaAlterar);
        if (model.PermiteImprimir()) {
            $('#button-imprimir-orcamento').popover('destroy');
        }
    },

    editarUltimoPedidoVendedor: function () { //FNX-3817

        global.blockUI();

        var $abrirMenuPrincipal = $("#abrirMenuPrincipal");
        var $botaoPesquisar = $("#pesquisarPedidosBotaoPesquisar");// FNX-4975
        $botaoPesquisar.prop('disabled', true);// FNX-4975
        $abrirMenuPrincipal.prop('disabled', true);
        $abrirMenuPrincipal.hide();// FNX-4975

        this.model.DesabilitarBotoes(true);
        var self = this;

        global.ajax({
            url: "/Orcamento/EditarUltimoOrcamentoVendedor",
            type: "post",
            success: function (data) {

                if (!data || data.HasErrors) {
                    $abrirMenuPrincipal.prop('disabled', false);
                    $botaoPesquisar.prop('disabled', false);// FNX-4975
                    self.model.DesabilitarBotoes(false);
                    $abrirMenuPrincipal.show();// FNX-4975
                    global.unblockUI();
                    return;
                }

                window.location.href = "/Orcamento/EditarOrcamento?numeroOrcamento=" + data.Numero + "&tipoOrcamento=" + data.TipoOperacao;
            },
            error: function () { self.model.DesabilitarBotoes(false); }
        });
    },

    validarVendedorOrcamentoUnificado: function () { // 427169
        if (this.model && this.model.VendedorParaOrcamentoUnificado && this.model.VendedorParaOrcamentoUnificado()) {
            globalMU.showErrorMessage("O vendedor informado não pode ser utilizado para vendas.<br>Este vendedor é utilizado apenas para orçamentos unificados.");
            return true;
        }
        return false;
    },

    editar: function () {

        if (!this.model.OrcamentoSelecionado || !this.model.OrcamentoSelecionado() || !this.model.PermitidoAlterar()) {
            return;
        }
        if (this.validarVendedorOrcamentoUnificado()) { // 427169
            return;
        }
        global.blockUI();

        var $abrirMenuPrincipal = $("#abrirMenuPrincipal");
        var $botaoPesquisar = $("#pesquisarPedidosBotaoPesquisar");
        $botaoPesquisar.prop('disabled', true);// FNX-4975
        $abrirMenuPrincipal.prop('disabled', true);
        this.model.DesabilitarBotoes(true);
        $abrirMenuPrincipal.hide();// FNX-4975

        var self = this;
        var numeroPedido = this.model.OrcamentoSelecionado().NumeroPedido();
        var tipoOrcamento = this.model.OrcamentoSelecionado().TipoOrcamento();
        var acao = "ALTERAR";

        global.ajax({
            url: "/Orcamento/AutorizarAcoesOrcamento",
            type: "post",
            data: {
                tipoOrcamento: tipoOrcamento,
                acao: acao
            },
            success: function (data) {

                if (!data || data.HasErrors) {
                    $abrirMenuPrincipal.prop('disabled', false); // FNX-4975
                    $botaoPesquisar.prop('disabled', false);
                    self.model.DesabilitarBotoes(false);
                    global.unblockUI();
                    return;
                }

                window.location.href = "/Orcamento/EditarOrcamento?numeroOrcamento=" + numeroPedido + "&tipoOrcamento=" + tipoOrcamento;
            }
        });
    },

    consultar: function () {

        if (!this.model.OrcamentoSelecionado || !this.model.OrcamentoSelecionado()) {
            return;
        }

        this.model.DesabilitarBotoes(true);

        var self = this;
        var numeroPedido = this.model.OrcamentoSelecionado().NumeroPedido();
        var tipoOrcamento = this.model.OrcamentoSelecionado().TipoOrcamento();
        var acao = "CONSULTAR";

        global.ajax({
            url: "/Orcamento/AutorizarAcoesOrcamento",
            type: "post",
            data: {
                tipoOrcamento: tipoOrcamento,
                acao: acao
            },
            success: function (data) {

                if (!data || data.HasErrors) {
                    self.model.DesabilitarBotoes(false);
                    return;
                }

                window.location.href = "/Orcamento/ConsultarOrcamento?numeroOrcamento=" + numeroPedido + "&tipoOrcamento=" + tipoOrcamento;
            }
        });
    },

    duplicar: function () {

        if (!this.model.PermitidoDuplicar()) {
            return;
        }
        if (this.validarVendedorOrcamentoUnificado()) { // 427169
            return;
        }

        this.model.DesabilitarBotoes(true);

        var self = this;
        var numeroPedido = this.model.OrcamentoSelecionado().NumeroPedido();
        var tipoOrcamento = this.model.OrcamentoSelecionado().TipoOrcamento();
        var acao = "DUPLICAR";

        global.ajax({
            url: "/Orcamento/AutorizarAcoesOrcamento",
            type: "post",
            data: {
                tipoOrcamento: tipoOrcamento,
                acao: acao
            },
            success: function (data) {

                if (!data || data.HasErrors) {
                    self.model.DesabilitarBotoes(false);
                    return;
                }

                global.ajax({
                    url: "/Orcamento/AutorizarDuplicacaoOrcamento",
                    type: "post",
                    data: {
                        numeroPedido: numeroPedido
                    },
                    success: function (data) {
                        if (!data || data.HasErrors) {
                            self.model.DesabilitarBotoes(false);
                            return;
                        }

                        window.location.href = "/Orcamento/DuplicarOrcamento?numeroOrcamento=" + numeroPedido + "&tipoOrcamento=" + tipoOrcamento;
                    }
                });
            }
        });
    },

    trocarFilial: function () // FNX-5036
    {
        if (!this.model.OrcamentoSelecionado || !this.model.OrcamentoSelecionado())
            return;
        if (this.model.TipoOrcamentoNovo() !== 'Venda')
            return;
        if (this.validarVendedorOrcamentoUnificado()) { // 427169
            return;
        }

        var orcamento = ko.mapping.toJS(this.model.OrcamentoSelecionado());

        if (orcamento.CodigoSituacaoVenda != "A" && parametroSistema.obter("SOLICITAR_SENHA_TROCA_FILIAL_ORCAMENTO").Valor === "S") {
            global.showWarnMessage("Troca de filial é permitida somente para orçamento com situação APENAS EM ORÇAMENTO.")
            return;
        }

        this.trocarFilialOrcamentoController = this.showView({
            region: {
                name: "trocarFilialOrcamentoRegion",
                selector: "#trocarFilial-orcamento"
            },
            controller: {
                type: TrocarFilialOrcamentoController,
                args: {
                    numeroPedido: this.model.OrcamentoSelecionado().NumeroPedido(),
                    orcamento: orcamento,
                    trocarFilialOrcamentoCallback: $.proxy(this.trocarFilialOrcamentoCallback, this),
                    controleExclusividadeCallback: $.proxy(this.controleExclusividadeCallback, this)
                }
            }
        });
    },

    cancelar: function () {

        if (!this.model.OrcamentoSelecionado || !this.model.OrcamentoSelecionado()) {
            return;
        }
        var orcamento = ko.mapping.toJS(this.model.OrcamentoSelecionado());

        this.cancelarOrcamentoController = this.showView({
            region: {
                name: "cancelarOrcamentoRegion",
                selector: "#cancelar-orcamento"
            },
            controller: {
                type: CancelarOrcamentoController,
                args: {
                    numeroPedido: this.model.OrcamentoSelecionado().NumeroPedido(),
                    tipoOrcamento: this.model.OrcamentoSelecionado().TipoOrcamento(),
                    orcamento: orcamento,
                    cancelarOrcamentoCallback: $.proxy(this.cancelarOrcamentoCallback, this),
                    controleExclusividadeCallback: $.proxy(this.controleExclusividadeCallback, this)
                }
            }
        });
    },

    clienteSelecionado: function (cliente) {
        if (!cliente) {
            return;
        }
        this.model.CodigoCliente(cliente.get("Codigo"));
        this.model.NomeCliente(cliente.get("Nome"));
        this.pesquisarClientesController.hide();
        this.show();
    },

    trocarFilialOrcamentoCallback: function () { // FNX-5036
        if (!this.trocarFilialOrcamentoController) {
            return;
        }

        this.excluirControleExclusividade();

        this.pesquisar();
        this.show();
    },

    cancelarOrcamentoCallback: function () {
        if (!this.cancelarOrcamentoController) {
            return;
        }

        this.excluirControleExclusividade();

        this.pesquisar(); // FNX-963
        this.show();
    },

    // Início - Controle de Exclusividade.
    controleExclusividadeCallback: function (regionName) {
        if (!this.controleExclusividadeCallback && !this.trocarFilialOrcamentoController) {
            return;
        }

        if (regionName === null) {
            this.excluirControleExclusividade();
        }
    },

    excluirControleExclusividade: function () {
        // 491123 — namespaced: sem isso, este unbind apagava TODO handler de beforeunload/unload
        // em window (inclusive o de orcamentoController, responsável pelo aviso de "orçamento em
        // andamento" ao fechar a aba), não só os de trocarFilialOrcamentoController/cancelarOrcamentoController.
        $(window).unbind("beforeunload.controleExclusividade");
        $(window).unbind("unload.controleExclusividade");

        global.ajax({
            url: "/Comum/ExcluirControleDeExclusividade",
            type: "post",
            async: false,
            data: {
                actionParameter: this.model.OrcamentoSelecionado().NumeroPedido(),
                nomeTabela: "PEDICLICAD"
            }
        });
    },
    // Fim - Controle de Exclusividade.

    notasFiscais: function () {

        this.ListarNotasFiscaisSaidaController = this.showView({
            region: {
                name: 'notasFiscaisPesquisaOrcamentoRegion',
                selector: '#notas-fiscais-pesquisa-orcamento-region'
            },
            controller: {
                type: ListarNotasFiscaisSaidaController,
                args: {
                    orcamento: this.model.OrcamentoSelecionado(),
                    modelPesquisa: this.model
                }
            }
        });
    },

    obterCodigoFilial: function () {
        return this.model.OrcamentoSelecionado().Filial();
    },

    itensNotaFiscal: function () {

        if (!this.ListarNotasFiscaisSaidaController) {
            return;
        }

        this.ListarNotasFiscaisSaidaController.itens();
    },
    lotesNotaFiscal: function () {

        if (!this.ListarNotasFiscaisSaidaController) {
            return;
        }
        this.ListarNotasFiscaisSaidaController.lotes();
    },
    entregaNotaFiscal: function () {

        if (!this.ListarNotasFiscaisSaidaController) {
            return;
        }
        this.ListarNotasFiscaisSaidaController.entrega();
    },
    financeiroNotaFiscal: function () {

        if (!this.ListarNotasFiscaisSaidaController) {
            return;
        }
        this.ListarNotasFiscaisSaidaController.financeiro();
    },
    expedicaoNotaFiscal: function () {

        if (!this.ListarNotasFiscaisSaidaController) {
            return;
        }
        this.ListarNotasFiscaisSaidaController.expedicao();
    },
    obterInformacoesEmail: function (callback) {
        orcamentoUtil.obterInformacoesEmailPorNumero(this.model.OrcamentoSelecionado().NumeroPedido(), callback);
    },
    validarImpressaoOrcamento: function (e) {

        if (this.model.OrcamentoSelecionado().PermiteImprimir()) {
            return true;
        }

        var $target = $(e.target);
        $target.attr('data-content', 'Situação do orçamento impede que seja impresso');
        $target.attr('data-toggle', 'popover');
        $target.attr('data-trigger', 'focus');
        $target.popover('show');
        return false;
    },
    devolucoes: function () {

        this.ListarNotasFiscaisEntradaController = this.showView({
            region: {
                name: 'notasFiscaisPesquisaOrcamentoRegion',
                selector: '#devolucoes-pesquisa-orcamento-region'
            },
            controller: {
                type: ListarNotasFiscaisEntradaController,
                args: {
                    orcamento: this.model.OrcamentoSelecionado(),
                    modelPesquisa: this.model
                }
            }
        });
    },
    itensDevolucao: function () {

        if (!this.ListarNotasFiscaisEntradaController) {
            return;
        }
        this.ListarNotasFiscaisEntradaController.itens();
    },

    financeiroDevolucao: function () {

        if (!this.ListarNotasFiscaisEntradaController) {
            return;
        }
        this.ListarNotasFiscaisEntradaController.financeiro();
    }
});
